<script setup lang="ts">
withDefaults(defineProps<{
  width?: string
  height?: string
  placeholder?: {
    iconSize?: string
    iconName?: string
    withText?: boolean
  }
}>(), { placeholder: () => ({ iconSize: '100px', withText: true }) })
</script>

<template>
  <div
    class="grid place-content-center h-full w-full rounded text-white bg-hos-blue select-none"
    :class="$attrs.class"
    :style="{ width, height }"
  >
    <div class="text-center">
      <Icon
        :name="placeholder.iconName ?? 'material-symbols:forklift'"
        :size="placeholder.iconSize || '100px'"
      />
      <p v-if="placeholder.withText">
        {{ $t('customerModule.missingImage.placeholder') }}
      </p>
    </div>
  </div>
</template>
